export { default } from './SWShortBanner';
